export { EvidentlyOverridesWidget as default, EvidentlyOverridesWidgetPanel } from './widget';
